import React from 'react';
import { isBigBullet } from './helpers';
import { StepperItem } from './StepperItem';
import { StepperWrapper } from './StepperWrapper';
var Stepper = _ref => {
  var {
    children,
    noStartPadding,
    UNSAFE_props
  } = _ref;
  var filteredChildren = React.Children.toArray(children).filter(React.isValidElement);
  var hasNoBigBullets = filteredChildren.every(child => !isBigBullet({
    customBulletContent: child.props.customBulletContent,
    state: child.props.state
  }));
  return /*#__PURE__*/React.createElement(StepperWrapper, UNSAFE_props, filteredChildren.map((child, i) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: i
  }, /*#__PURE__*/React.cloneElement(child, {
    isLast: filteredChildren.length === i + 1,
    noStartPadding: noStartPadding && hasNoBigBullets
  }))));
};
Stepper.displayName = 'Stepper';
Stepper.Item = StepperItem;
export { Stepper };
//# sourceMappingURL=index.js.map